import React, { useEffect, useState, useRef } from 'react'
import { Checkbox } from 'antd'
import style from './index.module.scss'
import img from './img.png';
import msgicon from './msgicon.png';
import quoteicon from './quoteicon.png';
import useStore from '../../store/useStore';
import user_default from '../../static/image/user_default.png';
import moment from "moment";
import MarkdownMsg from "../markDown"
interface Props {
    deep: number; // 数据层级深度，树形结构深度
    path: number[];// 当前节点所在index索引的路径数组 [[],[],[[],[b]]]比如b所在path[3,2]
    onContentClick?: any;
    onExpendClick?: any;
    onExpendQuote?: any;
    list?: any[];
    showQuoteCheck?: boolean;
    // quoteCheck?: any[];
    onQuoteCheckChange?: any;
    onClickExpendPage?: any;
    expandpage?: boolean;
    quoteitems?: any[];
    toReply?: any;
    order?: 'talk' | 'send';
    focusId?: string;
    toquote?: any;
}

interface State {
}

const MsgItem = (props: Props) => {
    const [state, setState] = useState<State>({

    });
    const { store, dispatch } = useStore();
    const contentClick = (e: any, msg: any) => {
        if (e.button === 2) {
            props.onContentClick(e, msg);
        }
    }
    const clickExpend = (e: any, msg: any, nav?: boolean) => {
        props.onExpendClick(e, msg, nav);
    }

    const clickExpendPage = (e: any, msg: any) => {
        props.onClickExpendPage(e, msg);
    }

    const expandQuote = (e: any, msg: any, nav?: any) => {
        props.onExpendQuote(e, msg, nav);
    }

    const onQuoteCheckChange = (e: any, msg: any, path: number[]) => {
        props.onQuoteCheckChange(e, msg, path);
    }

    const render = (
        <div className={style.msglist}>
            {
                (props.list || []).map((msg: any, k: number) => {
                    return (<div key={k}
                        id={msg.id}
                        className={style.msglistitem + ' ' +
                            ((msg.senderId == store.userInfo.id) && (props.order !== 'talk') ? style.own : '')
                            + ' ' + (props.focusId === msg.id ? style.focus : '')}>
                        {
                            props.showQuoteCheck ?
                                <div className={style.msglistquotecheck}>
                                    <Checkbox
                                        checked={
                                            !!(props.quoteitems || []).find(v => {
                                                return v.id === msg.id
                                            })
                                        }
                                        onChange={(e: any) => {
                                            onQuoteCheckChange(e, msg, [...props.path, k]);
                                        }}></Checkbox>
                                </div> : null
                        }
                        <div className={style.msglistavatar}>
                            <img src={msg.avatar || img}
                                onError={(e: any) => { e.target.onerror = null; e.target.src = user_default }}></img>
                        </div>
                        <div className={style.msglistinfo}>
                            <div className={style.msglisthead}>
                                <div className={style.msglistname}>
                                    {msg.name || '开发团队'}
                                </div>
                                {
                                    props.deep === 1 ?
                                        <div className={style.msglistisreplyout}
                                            onClick={() => {
                                                props.toReply(msg.reply)
                                            }}>
                                            {
                                                msg.replyData ?
                                                    <img className={style.msglistisreply}
                                                        src={msgicon} /> : null
                                            }
                                        </div> : null
                                }
                                <div className={style.msglisttime}>
                                    {moment(msg.sendTime).format("YYYY-MM-DD HH:mm:ss") || '-'}
                                </div>
                            </div>
                            <div className={style.msglistcontent}>
                                {
                                    msg.quoteData && msg.quoteData.length > 1 &&
                                    !msg.expandquote &&
                                    <div className={style.quotelistnav}>
                                        <img className={style.quoteicon}
                                            src={quoteicon}></img>
                                        <div className={style.quoteimgs}>
                                            {
                                                (msg.quoteData || []).map((q: any, qk: number) => {
                                                    return <img src={q.avatar || img}
                                                        onError={(e: any) => { e.target.onerror = null; e.target.src = user_default }}
                                                        key={qk} />
                                                })
                                            }
                                        </div>
                                        <div className={style.quotelistlink}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                e.preventDefault();
                                                expandQuote(e, msg)
                                            }}>
                                            展开引用内容
                                        </div>
                                    </div>
                                }
                                {
                                    msg.quoteData && (msg.quoteData.length > 1 &&
                                        msg.expandquote || msg.quoteData.length === 1) &&
                                    <div className={style.quotelist}>
                                        {
                                            msg.quoteData.map((quo: any, quoidx: number) => {
                                                return <div className={style.quoteitem}
                                                    key={quoidx}
                                                    onClick={() => {
                                                        props.toquote(msg.quote[quoidx])
                                                    }}>
                                                    <div className={style.quoteitemtop}>
                                                        <div className={style.quoteavatar}>
                                                            <img src={quo.avatar || img}
                                                                onError={(e: any) => { e.target.onerror = null; e.target.src = user_default }} />
                                                        </div>
                                                        <div className={style.quotename}>
                                                            {quo.name || '开发团队'}
                                                        </div>
                                                        {
                                                            (quoidx === 0 &&
                                                                msg.quoteData.length > 1) ?
                                                                <div className={style.quotelistlink}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        e.preventDefault();
                                                                        expandQuote(e, msg, true)
                                                                    }}>
                                                                    收起引用内容
                                                                </div> : null
                                                        }
                                                    </div>
                                                    <div className={style.quotecontent}>
                                                        <MarkdownMsg id={msg.id} content={
                                                            msg.content &&
                                                            msg.content[0] &&
                                                            msg.content[0].mime === "text/plain" &&
                                                            msg.content[0].value
                                                        } />
                                                        {/* {
                                                            quo.content &&
                                                            quo.content[0] &&
                                                            quo.content[0].mime === "text/plain" &&
                                                            quo.content[0].value
                                                        } */}
                                                    </div>
                                                </div>
                                            })
                                        }
                                    </div>
                                }
                                <div className={style.msglisttxt}
                                    onContextMenu={(e) => {
                                        e.preventDefault();
                                        contentClick(e, msg);
                                    }}>
                                    <MarkdownMsg id={msg.id} content={
                                        msg.content &&
                                        msg.content[0] &&
                                        msg.content[0].mime === "text/plain" &&
                                        msg.content[0].value
                                    } />

                                </div>
                                {
                                    props.order === 'talk' ? <>
                                        {
                                            (msg.byReply && msg.byReply.length > 0) ?
                                                !msg.expand ?
                                                    <div className={style.msglistexpand}>
                                                        还有{msg.byReply.length}条回复
                                                        <div className={style.msglistexpandbtn}
                                                            onClick={(e) => {
                                                                clickExpend(e, msg);
                                                            }}>
                                                            点击展开
                                                        </div>
                                                        {
                                                            props.deep > 3 && !props.expandpage &&
                                                            <div className={style.msglistexpandbtn}
                                                                onClick={(e) => {
                                                                    clickExpendPage(e, msg);
                                                                }}>
                                                                页面展开
                                                            </div>
                                                        }
                                                    </div> :
                                                    <div className={style.msglistexpand}>
                                                        <div className={style.msglistexpandbtn}
                                                            onClick={(e) => {
                                                                clickExpend(e, msg, true);
                                                            }}>
                                                            点击收起
                                                        </div>
                                                    </div> :
                                                null
                                        }
                                        {
                                            msg.byReplyData && msg.byReplyData.length > 0 &&
                                            msg.expand &&
                                            <div className={style.msglistline}></div>
                                        }
                                        {
                                            msg.byReplyData && msg.byReplyData.length > 0 &&
                                            (props.deep <= 3 || (
                                                props.deep > 3 &&
                                                props.expandpage
                                            )) && msg.expand &&
                                            <div className={style.reply}>
                                                <MsgItem
                                                    focusId={props.focusId}
                                                    order={props.order}
                                                    toReply={props.toReply}
                                                    quoteitems={props.quoteitems}
                                                    path={[...props.path, k]}
                                                    onClickExpendPage={props.onClickExpendPage}
                                                    onQuoteCheckChange={props.onQuoteCheckChange}
                                                    showQuoteCheck={props.showQuoteCheck}
                                                    list={msg.byReplyData}
                                                    deep={props.deep + 1}
                                                    expandpage={props.expandpage}
                                                    onExpendClick={props.onExpendClick}
                                                    onContentClick={props.onContentClick}
                                                    onExpendQuote={props.onExpendQuote}
                                                    toquote={props.toquote}></MsgItem>
                                            </div>
                                        }
                                    </> : null
                                }
                            </div>
                        </div>
                    </div>)
                })
            }
        </div>
    )

    return render
}

export default MsgItem
